import {BaseLayout} from "../components/misc";
import {Plan, ListGroupWithNav, SummaryTable} from "../components";
import {useCategories} from "../hooks";
import {useState} from "react";
import type {IPlanItem} from "../components/PlanItem";
import {v4 as uuidv4} from "uuid";
import {Helpers} from "../utils";


export default function ConfiguratorScreen(props) {
  const categoryService = useCategories();
  const [showPlacements, setShowPlacements] = useState(false);
  const [deletionMode, setDeletionMode] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);


  const handleEditElement = (oldItem, newItem) => {
    const arr = [...props.elements];
    const idx = arr.findIndex(el => el.id === oldItem.id);
    if (idx !== -1) {
      arr[idx] = {...oldItem};

      let product = null;
      categoryService.items.find(c => {
        product = c.products.find(p => p.id === selectedProduct.id);
        return product;
      })

      arr.push({
        ...newItem,
        product,
      })
      props.onChangeElements(arr);
    }
  }


  const handleClickProduct = (item) => {
    let product = null;
    categoryService.items.find(c => {
      product = c.products.find(p => p.id === item.id);
      return product;
    })
    setSelectedProduct(product);
    setShowPlacements(true);
  }

  const handleDeleteElement = (id) => {
    // confirm('Czy chcesz usunąć ten element?')
  }

  const handleEdit = () => {
  }

  const handleEndEditing = () => {
    setSelectedProduct(null);
    setShowPlacements(false);
  }

  const addElement = (e, scale = 1) => {
    if(e.touches?.length) {
      e = e.touches[0];
    }
    const rect = e.target.getBoundingClientRect();
    let x = e.clientX - rect.left;
    let y = e.clientY - rect.top;

    x = Math.round(x / 10) * 10
    y = Math.round(y / 10) * 10


    const arr = [...props.elements];
    arr.push({
      id: uuidv4(),
      product: selectedProduct,
      elements: [],
      x,
      y,
    })
    handleEndEditing()
    props.onChangeElements(arr);
  }

  const handleDelete = (id) => {
    const arr = [...props.elements];
    const idx = arr.findIndex(el => el.id === id);
    if(idx !== -1) {
      arr.splice(idx, 1);
      props.onChangeElements(arr);
    }
  }

  const handleCancelActions = () => {
    handleEndEditing();
  }

  const handleEditCustomElements = (id, customElements) => {
    const arr = [...props.elements];
    const idx = arr.findIndex(el => el.id === id);
    if(idx !== -1) {
      arr[idx].elements = customElements;
    }
    handleEndEditing()
    props.onChangeElements(arr);
  }

  const listGroupWithNavItems = categoryService.items.map(c => ({
    ...c,
    items: c.products.map(i => ({
      id: i.id,
      title: i.name,
      text: i.description,
      price: i.price,
      subtitle: i.width ? `${i.width}x${i.height}${i.depth ? `x${i.depth}` : ''}cm` : '',
      image: i.gallery?.rendered_items.find(i => i.type === 'cover')?.url,
    }))
  }))

  return (
    <BaseLayout>

      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-3 col-lg-4">
            <div className="mb-4">
              <h2 className="mb-4">Materialien</h2>
              <ListGroupWithNav
                selectedProduct={selectedProduct}
                items={listGroupWithNavItems}
                onClickProduct={handleClickProduct}
              />
            </div>
          </div>
          <div className="col-xl-9 col-lg-8">
            <div className="mb-4">
              <h2 className="mb-4">Planen</h2>
              <p>Klicken Sie auf das ausgewählte Element und setzen Sie es in den Plan.</p>
              <Plan
                elements={props.elements}
                selectedProduct={selectedProduct}
                showPlacements={showPlacements}
                deletionMode={deletionMode}
                onEditElement={handleEditElement}
                onEdit={handleEdit}
                onEndEditing={handleEndEditing}
                onDeleteElement={handleDeleteElement}
                addElement={addElement}
                onDelete={handleDelete}
                cancelActions={handleCancelActions}
                editCustomElements={handleEditCustomElements}
                toggleDeletionMode={() => setDeletionMode(prev => !prev)}
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xl-3 col-lg-4"/>
          <div className="col-xl-9 col-lg-8">
            <h2 className="mb-4">Zusammenfassung:</h2>
            <div>
              <SummaryTable cart={props.cart}/>
              <div className="form-check form-check-inline mb-3">
                <label className="form-check-label">
                  <input type="checkbox" className="form-check-input" checked={props.montazChecked} onChange={props.toggleMontaz}/>
                  Montage in Deutschland (+500 €)
                </label>
              </div>
              <div className="form-check form-check-inline mb-3">
                <label className="form-check-label">
                  <input type="checkbox" className="form-check-input" checked={props.rejestracjaJednostkiChecked} onChange={props.toggleRejestracjaJednostki}/>
                  Anmeldung des Wasserfahrzeuges und Erledigung aller Formalitäten für den Auftraggeber (+120 €)
                </label>
              </div>
              <p>
                Die Installation von der Wasserelektrik, Kanalisation oder Dauerbeleuchtung auf dem Steg ist nach vorheriger Absprache mit dem Auftragnehmer möglich.
              </p>
            </div>
            <div style={{textAlign: 'right'}}>
              <button type="button" className="btn btn-primary" onClick={props.nextStep} disabled={props.elements.length < 1}>WEITER</button>
            </div>
          </div>
        </div>

      </div>

    </BaseLayout>
  );
}
